<script setup>
/**
 * FormControlPagesDisplayInSitemap
 * Composition-based wrapper around the standard checkbox form control.
 * Evaluates page structure categories on mount, dropping visual layout
 * presence unless the active page element represents a structured Listing profile.
 */
import {onMounted} from 'vue'
import FormControlTypeCheckbox from "@/common/form-control-type/FormControlTypeCheckbox.vue"

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number, Array],
        default: null
    }
})

// --- Lifecycle ---

onMounted(() => {
    /**
     * Contextual visibility guard: If this page element's layout profile
     * is not 'Listing', drop visibility from the orchestration form layer.
     */
    if (props.field) {
        props.field.hidden = props.currentData?.type !== 'Listing'
    }
})
</script>

<template>
    <FormControlTypeCheckbox v-bind="$props" v-if="!field.hidden"/>
</template>